import React, { Component } from 'react';
import { Authenticator, Greetings } from 'aws-amplify-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { Brand, ThemeToggle, LogoMark } from './header';
import './authGate.css';

/**
 * Shows a branded sign-in page until Amplify reports the user as signed in,
 * then renders the wrapped app. The wrapped component receives `authData` and
 * `onStateChange`, matching what withAuthenticator used to pass.
 */
export default function withAuthGate(Comp) {
  return class AuthGate extends Component {
    state = { authState: 'loading', authData: null };

    handleStateChange = (authState, authData) => {
      this.setState({ authState, authData });
    }

    render() {
      const { authState, authData } = this.state;

      if (authState === 'signedIn') {
        return <Comp {...this.props} authState={authState} authData={authData} onStateChange={this.handleStateChange} />;
      }

      const loading = authState === 'loading';
      return (
        <div className={'auth' + (loading ? ' is-loading' : '')}>
          <div className="backdrop" aria-hidden="true" />
          {loading && (
            <div className="auth__splash" role="status" aria-label="Loading">
              <LogoMark size={48} />
            </div>
          )}
          <header className="topbar topbar--plain">
            <div className="topbar__inner container">
              <Brand />
              <div className="topbar__actions"><ThemeToggle /></div>
            </div>
          </header>
          <main className="auth__main container">
            <div className="auth__copy">
              <div className="pill"><span className="pulse-dot" />Free · private to your account · synced</div>
              <h1 className="display">
                Big work,<br />
                <span className="gradient-text">piece by piece<span className="gradient-dot">.</span></span>
              </h1>
              <p className="lede">
                A task list that understands progress. Split work into subtasks, estimate it in
                units, and see exactly how far along you are.
              </p>
              <ul className="checklist">
                <li><FontAwesomeIcon icon={faCheck} /> Nested subtasks with rolled-up totals</li>
                <li><FontAwesomeIcon icon={faCheck} /> Progress bars that actually mean something</li>
                <li><FontAwesomeIcon icon={faCheck} /> Light and dark mode</li>
              </ul>
            </div>
            <div className="auth__panel">
              <div className="window auth__window">
                <div className="window__bar">
                  <span className="window__dots"><i /><i /><i /></span>
                  <span className="window__path">progresstodo / account</span>
                </div>
                <div className="auth__form">
                  <Authenticator hide={[Greetings]} onStateChange={this.handleStateChange} />
                </div>
              </div>
            </div>
          </main>
        </div>
      );
    }
  };
}
